"use client";

import { useAddToList } from "@/app/hooks/useAddToList";
import { type StorefrontUrls } from "@/app/utilities/storefront-urls";
import { AddToListDropdown } from "@/composites/product";

export interface AddToListRootProps {
	sku: string;
	quantity: number;
	urls: StorefrontUrls;
}

export function AddToListRoot({ sku, quantity, urls }: AddToListRootProps) {
	const {
		isOpen,
		setOpen,
		status,
		wishlists,
		registries,
		onSelect,
		onCreateNew,
		submittingPk,
		addedPk,
		addedListName,
		viewListHref,
		errorMessage
	} = useAddToList({
		sku,
		quantity,
		urls: {
			login: urls.login ?? "/login",
			createWishlist: urls.createWishlist ?? "/account/wishlist-mnt",
			createRegistry: urls.createRegistry ?? "/account/registry-mnt",
			listViewBase: urls.listView ?? "/account/wishlists"
		}
	});

	return (
		<AddToListDropdown
			isOpen={isOpen}
			onOpenChange={setOpen}
			status={status}
			wishlists={wishlists}
			registries={registries}
			onSelect={onSelect}
			onCreateNew={onCreateNew}
			submittingPk={submittingPk}
			addedPk={addedPk}
			addedListName={addedListName}
			viewListHref={viewListHref}
			errorMessage={errorMessage}
		/>
	);
}
